// extracted by mini-css-extract-plugin
export var md = "768px";
export var questionPageQuestionsContainer = "QuestionPage_questionPageQuestionsContainer__3VK47";
export var shared = "\"../../shared.module.css\"";